import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, navigate } from 'raviger';
import { Button, Card, Col, Modal, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import L from "leaflet";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faInfoCircle, faPlusSquare, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { faTimesSquare } from '@fortawesome/pro-regular-svg-icons';
import Header from '../components/Header';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import ActionsDropdown from '../components/ActionsDropdown';
import LoadingLink from "../components/LoadingLink";

function BuildingManagement({ organization, id }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [removeRoom, setRemoveRoom] = useState({});

  const removeRoomSubmit = () => {
    axios.delete('/shelter/api/room/' + removeRoom.id + '/')
    .then(response => {
      setData(prev => ({...prev, rooms: prev.rooms.filter(room => room.id !== removeRoom.id)
      }));
      setShowModal(false);
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  const openModal = (room) => {
    setRemoveRoom(room);
    setShowModal(true);
  }

  const [data, setData] = useState({name:'', description: '', shelter: null, shelter_name:'', rooms:[], action_history:[]});

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchBuildingData = async () => {
      // Fetch Building Details data.
      await axios.get('/shelter/api/building/' + id + '/?incident=', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData(response.data);
          setIsLoading(false);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    fetchBuildingData();
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [organization]);

  return (
    <>
    <span className="mt-4 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
    <Header>
      <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization + '/manage/shelters/' + data.shelter)} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
      {data.name} - Manage Rooms
      <OverlayTrigger
        key={"new-room"}
        placement="bottom"
        overlay={
          <Tooltip id={`tooltip-new-room`}>
            Add new room
          </Tooltip>
        }
      >
        <Link style={{cursor:'pointer', marginLeft:'10px'}} href={`/${organization}/manage/shelters/buildings/${id}/rooms/new`}>
          <FontAwesomeIcon icon={faPlusSquare} size="sm" inverse />
        </Link>
      </OverlayTrigger>
    </Header>
    <Row className="flex-nowrap" style={{paddingBottom:"10px"}}>
      <Col style={{minWidth:"150px", maxWidth:"150px", marginLeft:"0px"}}>
          Room Name
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px"}}>
      </Col>
    </Row>
    {data.rooms.map(room => (
      <Card key={room.id} className="rounded mb-1" style={{maxWidth:"0px", marginLeft:"10px"}}>
        <div className="row no-gutters flex-nowrap">
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", borderTopLeftRadius:"0.25rem", borderBottomLeftRadius:"0.25rem", minWidth:"150px", maxWidth:"150px", backgroundColor:"#615e5e"}}>
            {room.name}
          </Col>
          <Col className="border" style={{paddingLeft:"3px", paddingTop:"2px", marginTop: "-1px", fontSize:"13px", minWidth:"100px", maxWidth:"100px", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", backgroundColor:"#615e5e"}}>
            <ActionsDropdown variant="secondary" title="Actions" style={{height:"26px", paddingTop:"0px"}}>
              <LoadingLink
                href={"/" + organization + "/manage/shelters/rooms/edit/" + room.id}
                isLoading={isLoading}
                className="d-block"
                label="Update Room"
              >
                <FontAwesomeIcon icon={faPencil} className="fas" inverse />
              </LoadingLink>
              <LoadingLink
                onClick={() => openModal(room)}
                isLoading={isLoading}
                className="d-block"
                label="Remove Room"
              >
                <FontAwesomeIcon icon={faTimesSquare} className="fas" inverse />
              </LoadingLink>

            </ActionsDropdown>
          </Col>
        </div>
      </Card>
    ))}
    </span>
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Room Removal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <b>Room Name: </b>{removeRoom.name}
        <br/><br/>
        <p style={{marginTop:"-10px", marginBottom:"-5px"}}>Are you sure you want to remove this room?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => removeRoomSubmit()}>
          Yes
        </Button>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default BuildingManagement
